export default __webpack_public_path__ + "static/yhyldzqqszw-49da9ca7589cc179aaf639a5756e04f4.png";